import type { SerializedStyles, Theme } from '@emotion/react';
import { css } from '@emotion/react';
import {
  HEADER_HEIGHT,
  HEADER_PADDING_X,
  MOBILE_HEADER_HEIGHT,
  MOBILE_SEARCH_HEADER_HEIGHT,
} from '@sites/constants/layout';

export const S = {
  header: (theme: Theme, isMobileAndSearchOpen: boolean): SerializedStyles => css`
    display: flex;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
    padding: ${theme.spacing.x5};
    height: ${isMobileAndSearchOpen ? MOBILE_SEARCH_HEADER_HEIGHT : MOBILE_HEADER_HEIGHT}px;
    color: ${theme.palette.primary.main};
    font-size: 14px;
    width: 100%;
    overflow: hidden;
    gap: ${theme.spacing.xl};
    z-index: ${theme.zIndex.header};

    ${theme.mq.lg} {
      height: ${HEADER_HEIGHT}px;
      font-size: 16px;
      padding: 0 ${theme.typography.pxToRem(HEADER_PADDING_X)};
    }

    background-color: ${theme.palette.surface.canvas};
    transition: all 0.3s ease-out;
    will-change: transform, height;
  `,
};
